import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { DocumentService } from 'src/app/Services/document/Documentservice';


@Component({
  selector: 'attachmentV2',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss']
})
export class AttachmentV2Component implements OnInit {

  //En este input se debe ingresar el nombre del BlobContainer que se va a afectar
  //En caso de no existir se crea el contenedor.
  @Output('blurAction') _blurAction: EventEmitter<any> = new EventEmitter();
  @Output('enterKey') _enterKey: EventEmitter<any> = new EventEmitter();
  @Input('preRowKey') preRowKey: string;
  @Input() container: string;
  @Input() masterContainer: string;
  @Input() uploadbool: boolean;
  @Input() admitedTypes: string;
  @Input() IdRequest: string;

  formFields = [];
  blobService;
  blobArray = [];
  files: File[] = [];
  tokenSAS: string;
  upload: boolean = false;
  admitedTypesArray : any = [];
  compareType: string;
  insertedItems: string;
  

  fileData: File = null;
  previewUrl: any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  constructor(
    private readonly documentService: DocumentService
  ) { }

  ngOnInit() {
    this.list()
    this.admitedTypesArray = this.admitedTypes != undefined ? this.admitedTypes.split(";") : []
  }

  /* 
  **
  Traer los documentos subidos por el usuario y 
  el documento de terminos y condiciones de etica y cumplimiento
  **
   */
  async list() {
    this.blobArray = [];
    const uploadedDocs = await this.documentService.getDocumentsbyRequest(this.IdRequest)
    const TermsConditionsEthic = await this.documentService.getUrlTyC(this.IdRequest)
    const ethicsFileName = "EthicsFile/" + this.container + ".docx"

    uploadedDocs.forEach(element => {
      this.blobArray.push({ "blob": {name: element.IdRequiredDocumentNavigation.Name, 
        extension: element.IdRequiredDocumentNavigation.Extension}
        , "downloadLink": element.FileUrl })
    });

    this.blobArray.push({ "blob": {name: ethicsFileName, 
      extension: "application/msword"}
      , "downloadLink": TermsConditionsEthic })

  }

  async Download(blobName) {
      window.open(blobName, '_blank','noopener,noreferrer')
  }


}
